var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62488 10.79C8.06488 13.62 10.3849 15.93 13.2149 17.38L15.4149 15.18C15.6849 14.91 16.0849 14.82 16.4349 14.94C17.5549 15.31 18.7649 15.51 20.0049 15.51C20.5549 15.51 21.0049 15.96 21.0049 16.51V20C21.0049 20.55 20.5549 21 20.0049 21C10.6149 21 3.00488 13.39 3.00488 4C3.00488 3.45 3.45488 3 4.00488 3H7.50488C8.05488 3 8.50488 3.45 8.50488 4C8.50488 5.25 8.70488 6.45 9.07488 7.57C9.18488 7.92 9.10488 8.31 8.82488 8.59L6.62488 10.79Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a7fb3d8af44044f068cd0ffb97142407.svg";
export { ForwardRef as ReactComponent };